<template>
    <v-tooltip :text="tooltip" location="top">
        <template v-slot:activator="{ props }">
            <v-icon
                :color="color"
                :icon="icon"
                v-bind="props"
            />
        </template>
    </v-tooltip>
</template>

<script lang="ts">
import {computed, defineComponent} from "vue"
import {useI18n} from "vue-i18n";

export default defineComponent({
    props: {
        phase: {
            type: Number,
            required: true,
        },
        text: {
            type: String
        }
    },
    setup(props: any) {
        const {t} = useI18n();
        const color = computed((): string => {
            switch (props.phase) {
                case true:
                    return 'trtTealGreen';
                case false:
                    return 'kpmgError-900';
                default:
                    return 'kpmgWarning-900';
            }
        })

        const icon = computed((): string => {
            switch (props.phase) {
                case true:
                    return 'mdi-check-circle-outline';
                case false:
                    return 'mdi-close-circle-outline';
                default:
                    return 'mdi-help-circle-outline';
            }

        })

        const text = computed((): string => {
            switch (props.phase) {
                case true:
                    return t('fileUpload.status.completed');
                case false:
                    return t('fileUpload.status.failed');
                default:
                    return props.text;
            }

        })

        const tooltip = computed((): string => {
            return props.text ? t(props.text) : text.value
        })


        return {
            // computed
            color,
            icon,
            tooltip,
        }
    }
})
</script>